import { Text } from '@bb/elements-web';
import { BuyerAgreementCheckbox, TabPane, Tabs } from 'components';
import React, { useContext, useState } from 'react';
import AppointmentBookingInternalContext from './AppointmentBookingInternalContext';
import InPersonTab from './InPersonTab';
import VirtualTab from './VirtualTab';

type TabKeyType = 'physical' | 'virtual';

type TabPaneType = {
  label: string | JSX.Element;
  key: TabKeyType;
  content: JSX.Element;
  shouldDisplay: boolean;
};

const AppointmentBookingInternalTabs: React.FC = () => {
  const { partialAppointmentConfig, listing, requiresBuyerAgreement } =
    useContext(AppointmentBookingInternalContext);
  const [selectedTabKey, setSelectedTabKey] = useState<TabKeyType>('physical');

  const hasVSFlag = listing!.org!.features.includes('VIRTUAL_SHOWINGS');

  const fullTabPaneList: TabPaneType[] = [
    {
      label: 'In Person Showing',
      key: 'physical',
      content: <InPersonTab />,
      shouldDisplay: true,
    },
    {
      label: '3D Virtual Showing',
      key: 'virtual',
      content: <VirtualTab />,
      shouldDisplay:
        partialAppointmentConfig!.isVirtualTourEnabled && hasVSFlag,
    },
  ];
  const tabPaneList = fullTabPaneList.filter(t => t.shouldDisplay);

  const handleTabClick = (key: TabKeyType) => {
    setSelectedTabKey(key);
  };

  return (
    <>
      {tabPaneList.length > 1 ? (
        <Tabs
          activeKey={selectedTabKey}
          onTabClick={handleTabClick}
          destroyInactiveTabPane
          tabBarStyle={{ margin: 0 }}
        >
          {tabPaneList.map(({ label, key, content }) => (
            <TabPane key={key} tab={<Text>{label}</Text>}>
              {content}
            </TabPane>
          ))}
        </Tabs>
      ) : (
        tabPaneList[0].content
      )}
      {requiresBuyerAgreement && <BuyerAgreementCheckbox />}
    </>
  );
};

export default AppointmentBookingInternalTabs;
